import React from "react";
import PropTypes from "prop-types";
import HorizontalSlider from "../HorizontalSlider";
import H from "../Typography/H";
import ProductCard from "../ProductCard";

import styles from "./clones.module.scss";
import trackEvent from "../../../utils/track-event";

function Clones(props) {
  const {clones} = props;
  return clones.length ? (
    <div className={styles.root}>
      <H level={2} className={styles.title}>
        Еще с этим дизайном
      </H>
      <div
        className={styles.content}
        onClick={() => {
          trackEvent({
            category: `closeup`,
            action: `click`,
            label: `more_this_design`
          });
        }}
      >
        <HorizontalSlider
          dots={false}
          slidesToScroll={1}
          slidesToShow={3}
          infinite={false}
          responsive={[
            {
              breakpoint: 1240,
              settings: {
                slidesToShow: 2
              }
            }
          ]}
        >
          {clones.map((item) => (
            <ProductCard key={item.id} content={item} className={styles.card} />
          ))}
        </HorizontalSlider>
      </div>
    </div>
  ) : null;
}

Clones.propTypes = {
  clones: PropTypes.array
};

export default Clones;
